import { createCustomPalette } from '../../packages/core/src/palette.js';
import { LEGACY_64_HEX } from './mard221.js';

export const STANDARD_PALETTE_ID = 'studio-standard-64-v1';

export const STANDARD_SERIES = Object.freeze({
  N: 'Neutral',
  R: 'Red',
  O: 'Orange',
  Y: 'Yellow',
  G: 'Green',
  B: 'Blue',
  T: 'Teal',
  P: 'Purple',
  M: 'Magenta',
  C: 'Skin and earth',
  X: 'Transparent',
});

const standardColors = [...LEGACY_64_HEX]
  .map(([code, hex], index) => {
    const series = code[0];
    return {
      id: code.toLowerCase(),
      code,
      name: `${STANDARD_SERIES[series] || series} ${String(index + 1).padStart(2, '0')}`,
      hex: code === 'N11' ? '#000000' : hex,
      series,
    };
  });

standardColors.unshift({
  id: 'x00',
  code: 'X00',
  name: 'Transparent',
  hex: '#FFFFFF',
  series: 'X',
  isTransparent: true,
});

export const STANDARD_PALETTE_PROVIDER = createCustomPalette({
  id: STANDARD_PALETTE_ID,
  name: 'Standard 64',
  colors: standardColors,
  source: 'internal-standard-palette-v1',
  anchors: Object.freeze({
    transparent: 'X00',
    white: 'N01',
    black: 'N11',
  }),
});
